import { render, staticRenderFns } from "./FacebookTable.vue?vue&type=template&id=1d70f429&"
import script from "./FacebookTable.vue?vue&type=script&lang=ts&"
export * from "./FacebookTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports